
function floatLabels(container) {
  const floats = container.querySelectorAll('.float__wrapper');
  floats.forEach(element => {
    const label = element.querySelector('label');
    const input = element.querySelector('input, textarea');
    input.addEventListener('keyup', event => {
      if (event.target.value !== '') {
        label.classList.add('label--float');
      } else {
        label.classList.remove('label--float');
      }
    });
  });
}

export default floatLabels;
